module.exports = __webpack_public_path__ + "static/media/thewhiteboxxx-com-c1278867.2ae831a3.jpg";